<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'커뮤니티'" class="sv5"></sub-visual>
        <div class="tab-list--primary-wrap">
            <ul class="tab-list tab-list--primary">
                <li><router-link to="/community/notice" class="button">공지사항</router-link></li>
                <li><router-link to="/community/reference" class="button">자료실</router-link></li>
                <li class="on"><router-link to="/community/qna" class="button">QnA</router-link></li>
            </ul>
        </div>

        <section class="section">
            <v-container>

                <tit-primary
                type="transformNone"
                sc="QnA"
                tit="QnA">
                </tit-primary>

                <div class="board-container">
                    <faq-list></faq-list>
                </div>

            </v-container>
        </section>
        
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import FaqList from "@/components/client/center/faqs/faq-list.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
		FaqList,
        TitPrimary,
    },
};
</script>